import { NEWSLETTER_TEMPLATES } from "@/data/newsletterTemplates";
import { FileText, ChevronRight } from "lucide-react";

export default function TemplateSelector({ onSelect }) {
  return (
    <div className="space-y-2" data-testid="template-selector">
      <p className="text-white/40 text-xs uppercase tracking-wider mb-3">Start from a template</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2">
        {NEWSLETTER_TEMPLATES.map((t) => (
          <button
            key={t.id}
            onClick={() => onSelect(t)}
            className="text-left p-3 bg-white/[0.02] border border-white/5 rounded-xl hover:bg-amber-500/5 hover:border-amber-500/20 transition-all group"
            data-testid={`template-${t.id}`}
          >
            <div className="flex items-start gap-2">
              <FileText className="w-4 h-4 text-amber-400/60 mt-0.5 flex-shrink-0" />
              <div className="flex-1 min-w-0">
                <p className="text-white/80 text-sm font-medium group-hover:text-amber-400 transition-colors">{t.name}</p>
                <p className="text-white/30 text-xs mt-0.5 line-clamp-1">{t.description}</p>
              </div>
              <ChevronRight className="w-3.5 h-3.5 text-white/10 group-hover:text-amber-400/50 flex-shrink-0 mt-0.5" />
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
